import {
  List,
  Datagrid,
  TextField,
  NumberField,
  usePermissions,
} from "react-admin";
import { useNavigate } from "react-router-dom";
import { Typography, Box } from "@mui/material";

export const FeedbackTypeSummaryList = () => {
  const navigate = useNavigate();
  const { permissions = [] } = usePermissions();

  const canRead =
    permissions.includes("forms.read") ||
    permissions.includes("forms.*") ||
    permissions.includes("*");

  if (!canRead) return null;

  return (
    <List perPage={25} title="Responses">
      {/* ✅ SAME UI AS FORMTYPE */}
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Responses
        </Typography>
      </Box>

      <Datagrid
        bulkActionButtons={false}
        rowClick={(id, resource, record) =>
          navigate(
            `/feedback-submissions?filter=${encodeURIComponent(
              JSON.stringify({
                feedback_type_id: record.id,
              })
            )}`
          )
        }
        sx={{
          "& .RaDatagrid-headerCell": {
            textAlign: "left",
          },
          "& .RaDatagrid-rowCell": {
            textAlign: "left",
          },
        }}
      >
        <TextField source="name" label="Form Type" />
        <NumberField source="response_count" label="Responses" />
      </Datagrid>
    </List>
  );
};